import {TimePicker, TimePickerChangeEvent} from "@progress/kendo-react-dateinputs"
import {FieldRenderProps} from "@progress/kendo-react-form"
import React, {useState} from "react"

const TimeComponent = (fieldRenderProps: FieldRenderProps) => {
    const {name, label, value, min, max, updateTime} = fieldRenderProps
    const [testTime, setTestTime] = useState<string>(value)

    const onChangeTime = (event: TimePickerChangeEvent) => {
        setTestTime(event.target.value?.toString() ?? value)
    }

    const onBlurTime = (event: any) => {
        if (event.target.tagName === "INPUT") {
            updateTime(testTime)
        }
    }

    return (
        <TimePicker
            required
            name={name}
            value={new Date(testTime)}
            format="HH:mm"
            onChange={onChangeTime}
            onBlur={onBlurTime}
            label={label}
            min={min}
            max={max}
            steps={{hour: 1, minute: 5}}
        />
    )
}

export default TimeComponent

